import { render, staticRenderFns } from "./ATouristList.vue?vue&type=template&id=51146596&"
import script from "./ATouristList.vue?vue&type=script&lang=js&"
export * from "./ATouristList.vue?vue&type=script&lang=js&"
import style0 from "./ATouristList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports